import {ContentInfusionData, CTA} from '../../types/travel.ts'

interface ContentInfusionStyle3Props {
    data: ContentInfusionData
}

export function ContentInfusionStyle3({data}: ContentInfusionStyle3Props) {
    if (!data) return null;

    const {title, image, stamp,stamp_position_x,stamp_position_y, cta } = data;

    const isValidCTA = (cta: CTA | string): cta is CTA => {
        return typeof cta === 'object' && cta !== null && 'title' in cta && 'url' in cta;
    };

    const bg = image ? `background-image: url(${image})` : "";
    let stamp_position = '';
    if(stamp) {
        const stamp_x = stamp_position_x ? `left: ${stamp_position_x}%;` : "";
        const stamp_y = stamp_position_y ? `top: ${stamp_position_y}%;` : "";
        stamp_position = `${stamp_x}${stamp_y}`;
    }

    const handleTriggerClick = (cta : string | CTA) => {
        if (isValidCTA(cta)) {
            window.location.href = cta.url;
        }
    };

    return (
        <div  onClick={() => handleTriggerClick(cta)} className={`text-white bg-gray-500 content-infusion style-3 hidden lg:block bg-cover bg-no-repeat ${isValidCTA(cta) ? 'cursor-pointer' : ''}`} style={bg}>
            <div className="pt-10 pb-9 px-8 relative content-infusion-inner flex h-full items-center flex-col justify-between">
                {/* Titel */}
                <h2
                    className="text-left w-full font-semibold leading-[2.2rem] text-[28px] font-reckles title"
                    dangerouslySetInnerHTML={{ __html: title }}
                />

                {/* stamp */}
                {stamp && (
                    <span class={`inline-flex absolute -translate-x-1/2 -translate-y-1/2`} style={stamp_position}>
                        <img src={stamp} alt={"Stempel"} title={"Stempel"} class={`inline-flex min-w-23`} />
                    </span>
                )}

                {/* CTA */}
                {isValidCTA(cta) && cta.title && cta.url && (
                    <div className="mt-9 w-full text-center">
                        <a
                            href={cta.url}
                            target={cta.target || '_self'}
                            className="btn white height-60"
                        >
                            {cta.title}
                        </a>
                    </div>
                )}

            </div>
        </div>
    )
}
